import { createAction, props } from '@ngrx/store';
import { UserMeResponse } from '../../services/UserService';
import { User } from '../../models/User';

// Get current user (me)
export const loadUserMe = createAction('[User] Load User Me');

export const loadUserMeSuccess = createAction(
  '[User] Load User Me Success',
  props<{ userMeResponse: UserMeResponse }>()
);

export const loadUserMeFailure = createAction(
  '[User] Load User Me Failure',
  props<{ error: any }>()
);

// Clear current user
export const clearUserMe = createAction('[User] Clear User Me');
